import React from 'react';
import { Button, Form, Input, Modal, notification, Row, Select, Typography, Upload } from "antd";
import { DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import ApiService from "../../../services/ApiService"
import { API_BASE_URL, ASSET_BASE_URL } from "../../../configs/AppConfig";
import PdforImage from "../../../components/util-components/PdforImage";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;

export default class ModalAddDoc extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    state = {
        visible: false,
        loading: false,
        doc: null,
        id: null
    };

    async show(id) {
        this.setState({ visible: true, id: id })
    }

    close() {
        this.setState({
            visible: false,
            loading: false,
            doc: null,
            id: null
        })
    }

    async onSubmit(data) {
        data.doc = this.state.doc
        this.setState({ loading: true })

        var res = await ApiService.post("/contact/document/add/" + this.state.id, data)

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            })
        }

        this.setState({ loading: false })
    }

    render() {
        return (
            <Modal
                width="100%"
                title={t`Ajouter un document`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <Form
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                    layout={"vertical"}
                >
                    <Form.Item
                        name="name"
                        label={<Trans>Nom du document</Trans>}
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                    >
                        <Input placeholder={t`Nom du document`} />
                    </Form.Item>

                    <Form.Item
                        label={<Trans>Document</Trans>}
                        name="doc"
                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                        shouldUpdate
                    >
                        {!this.state.doc && (
                            <Upload.Dragger
                                name="doc"
                                multiple={false}
                                accept="image/*,application/pdf"
                                onChange={({ file }) => {
                                    if (file.response && file.status === "done") {
                                        this.setState({ doc: file.response })
                                        this.form.setFieldValue("doc", file.response)
                                    }
                                }}
                                headers={{ authorization: localStorage.getItem("AUTH_TOKEN") }}
                                action={API_BASE_URL + "/upload/doc"}
                            >
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">
                                    <Trans>Cliquez ou faites glisser le fichier dans cette zone pour le télécharger</Trans>
                                </p>
                                <p><Trans>Image / PDF</Trans></p>
                            </Upload.Dragger>
                        )}

                        {this.state.doc && (
                            <Row style={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
                                <PdforImage url={ASSET_BASE_URL + "/" + this.state.doc} />
                                <Button
                                    danger
                                    style={{ marginLeft: 8 }}
                                    icon={<DeleteOutlined />}
                                    onClick={() => {
                                        this.setState({ doc: null })
                                        this.form.setFieldValue("doc", null)
                                    }}
                                />
                            </Row>
                        )}
                    </Form.Item>

                    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
